// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"resources_tsx_ModelViewer_Camera_DragIndicator_tsx":"da1c8cd4716e597c282a","resources_tsx_ModelViewer_ModelVariantSelector_tsx":"61b859826f3d4c3ba541","vendors":"6d5872db8eab799357f4","resources_tsx_ModelViewer_Standalone_Editor_Viewer_tsx":"03b4bd274fe36342c68a"}[chunkId] + ".js";
};